export default {
  props: ['model'],
  methods: {
    async invokeActionOnClick(actionOptions, params = {}) {
      if (!actionOptions) {
        return
      }
      // Обработка действия "Валидация полей"
      // Проверка виджетов у которых установлено свойство Required
      if (actionOptions?.FieldsValidation && this.dataSource) {
        
        // Получить результат валидации всех инпут виджетов со свойством Required
        let result = await this.parentDataWidget.validateRequiredFields()

        if (!result) {
          return
        }
      }

      // MicroFlow
      if (actionOptions.Type == 'RunMicroflow') {
        let microflowId = actionOptions.MicroFlow
        if (!microflowId) {
          return
        }
        
        let microflowProps = this.getMicroflowParameters(actionOptions.Parameters)
        const settings = {
          loadIndicator: actionOptions.LoadIndicator,
          loadIndicatorText: actionOptions.LoadIndicatorText
        }
        // process microflow parameters
        let startParams = {...params}
        if (actionOptions.Event) {
          startParams.EventName = actionOptions.Event,
          startParams.PageId = this.$route.name
        }
        this.$microFlowRunner.callMicroFlow(microflowId, startParams, microflowProps, settings)
        return
      }
      //re-read data source action
      if (actionOptions.Type === 'RereadDataSource') {
        this.$emit('callDataSourceAction', {
          action: '__RereadDataSource__',
          params
        })
        return
      }
      // JsActions
      if (actionOptions.Type == 'RunJsAction') {
        let jsActionId = actionOptions.JsAction
        if (!jsActionId) {
          return
        }

        let jsActionProps = this.createJsActionParameters(actionOptions.Parameters)
        const settings = {
          loadIndicator: actionOptions.LoadIndicator,
          loadIndicatorText: actionOptions.LoadIndicatorText
        }
        this.$jsActionsRunner.callJsActions(jsActionId, jsActionProps, settings)
        return
      }
      // datasource action
      if (
        (actionOptions.Type === 'dataSourceAction' || actionOptions.Type === 'PopUpMenu') &&
        this.dataSource
      ) {
        let action = params.popUpActionValue || actionOptions.Value
        this.$emit('callDataSourceAction', {
          action: action,
          params
        })
        return
      }
      let query = {}
      if (
        actionOptions.Type == 'OpenPage'
      ) {
        if (actionOptions.Parameters) {
          query = JSON.parse(actionOptions.Parameters)
          for (let i in query) {
            query[i] = this.getExternalSourceField(query[i])
          }
        }
        this.$router.push({ name: actionOptions.Page, query, params: { context: this.getExternalSourceField('Context')} })
      }
    },
    createJsActionParameters(parameters) {
      if (!parameters) {
        return {}
      }

      let props = {}
      for (const key in parameters) {
        props[key] = this.getExternalSourceField(parameters[key])
      }

      return props
    }
  }
}
  